/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A property definition containing jsonSchema values for the property
 * @export
 * @interface PropertyFromJsonSchema
 */
export interface PropertyFromJsonSchema {
	/**
	 * Label for the property.
	 * @type {string}
	 * @memberof PropertyFromJsonSchema
	 */
	title?: string;
	/**
	 * The data type of the property.
	 * @type {string}
	 * @memberof PropertyFromJsonSchema
	 */
	type?: PropertyFromJsonSchemaTypeEnum;
	/**
	 * A list of allowed values for the property.
	 * @type {Array<string>}
	 * @memberof PropertyFromJsonSchema
	 */
	_enum?: Array<string>;
}

/**
 * @export
 * @enum {string}
 */
export enum PropertyFromJsonSchemaTypeEnum {
	String = 'string',
}

/**
 * Check if a given object implements the PropertyFromJsonSchema interface.
 */
export function instanceOfPropertyFromJsonSchema(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function PropertyFromJsonSchemaFromJSON(json: any): PropertyFromJsonSchema {
	return PropertyFromJsonSchemaFromJSONTyped(json, false);
}

export function PropertyFromJsonSchemaFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PropertyFromJsonSchema {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		title: !exists(json, 'title') ? undefined : json['title'],
		type: !exists(json, 'type') ? undefined : json['type'],
		_enum: !exists(json, 'enum') ? undefined : json['enum'],
	};
}

export function PropertyFromJsonSchemaToJSON(value?: PropertyFromJsonSchema | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		title: value.title,
		type: value.type,
		enum: value._enum,
	};
}
